import { emitEvent } from '@jove-frontend/utils';
import axios from 'axios';
import { handleRequestConfig } from '../utils/axios';
import { getCurrentUserWebTimeZone } from '../utils/time';
var baseURL = process.env['NX_JOVE_API'];
var baseURLV2 = process.env['NX_JOVE_API_V2'];
var jobsBaseURL = process.env['NX_JOBS_API'];
var timeZone = getCurrentUserWebTimeZone();
export var api = axios.create({
  baseURL: baseURL,
  headers: {
    'Jove-Time-Zone': timeZone
  }
});
export var apiV2 = axios.create({
  baseURL: baseURLV2,
  headers: {
    'Jove-Time-Zone': timeZone
  }
});
api.interceptors.request.use(function (config) {
  return handleRequestConfig(config);
});
api.interceptors.response.use(function (response) {
  emitEvent === null || emitEvent === void 0 ? void 0 : emitEvent('jove-project-api-response', response);
  return response;
});
apiV2.interceptors.request.use(function (config) {
  return handleRequestConfig(config);
});
apiV2.interceptors.response.use(function (response) {
  emitEvent === null || emitEvent === void 0 ? void 0 : emitEvent('jove-project-api-response', response);
  return response;
});
export var jobsApi = axios.create({
  baseURL: jobsBaseURL
});